import React, { Component } from "react";
import { enqueueSnackbar } from "notistack";
import Loading from "./loader";
import { Descriptions, Menu, Typography, Input, Select} from "antd";
import { FolderOpenOutlined, FileDoneOutlined, SaveOutlined, ArrowLeftOutlined } from "@ant-design/icons";

class VoteMeetingRedact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Эмитент
            issuersData: null,
            issuerInput: "",
            filteredIssuers: [],
            selectedIssuer: null,
            address: "",
            issuerId: "",

            MeetingName: '',
            MeetingLocation: '',
            DesicionDate: '',
            DeadlineDate: '',
            ProtocolDate: '',
            RecordDate: '',
            MeetingDate: '',
            CheckinTime: '',
            MeetingOpenTime: '',
            VoteCountingTime: '',
            AnnualOrUnscheduled: '',
            Status: '',
            EarlyRegistration: '',
            FirstOrRepeated: '',
            MeetingClose: '',
            Closeout: '',
            RegistrarId: '1',
            MeetingUrl: '',
            InterOrExtraMural: '',
            IssuerId: '',
            IssuerFullname: '',
            IssuerMeetingLocation: '',
            RegistrarName: 'Ведение реестров компаний',
            isButtonDisabled: false,

            meetingId: null,
            loading: true
        };
    }

    async componentDidMount() {
        const { is_staff, is_superuser, match } = this.props;
        if (!is_staff && !is_superuser) {
            alert("Доступ запрещен");
            window.location.href = `/#/`;
            return;
        }

        const meetingId = match.params.meetingId;
        this.setState({ meetingId });

        await this.fetchIssuers();
        await this.fetchMeetingData(meetingId);
    }

    async componentDidUpdate(prevProps) {
        const { is_staff, is_superuser } = this.props;
        if (
            prevProps.is_staff !== this.props.is_staff ||
            prevProps.is_superuser !== this.props.is_superuser
        ) {
            if (!is_staff && !is_superuser) {
                alert("Доступ запрещен");
                window.location.href = `/#/`;
            }
        }
    }

    handleBackClick = () => {
        window.history.back();
    };

    handleRedactAgenda = () => {
        const { match } = this.props;
        const meetingId = match.params.meetingId;
        //const url = localStorage.getItem('url');
        window.location.href = `/#/voteAgendaRedact/${meetingId}/`;
    };

    handleRedactDocs = () => {
        const { match } = this.props;
        const meetingId = match.params.meetingId;
        //const url = localStorage.getItem('url');
        window.location.href = `/#/voteMeetingRedactDocs/${meetingId}/`;
    };

    fetchIssuers = async () => {
        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;

        try {
            const res = await fetch(`${API_ADDRESS}get_issuers/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });

            if (res.status === 401) {
                alert("Время сессии истекло. Пожалуйста, выполните вход.");
                document.getElementById("logoutBttn").click();
                return;
            }

            const data = await res.json();
            this.setState({
                issuersData: data.issuers || []
            });
        } catch (e) {
            console.error(e);
            this.setState({ error: "Произошла ошибка. Попробуйте еще раз.", loading: false });
        }
    };

    fetchMeetingData = async (meetingId) => {
        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;

        const res = await fetch(`${API_ADDRESS}get_meeting_adm/${meetingId}/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });

        const data = await res.json();

        // Извлекаем данные об эмитенте
        const issuer = data.issuer || {};
        const meeting = data.meeting || {};

        // Преобразуем статус обратно в строковое представление
        const statusMapping = {
            1: 'Ожидается',
            2: 'Разрешена регистрация',
            3: 'Разрешено голосование',
            4: 'Голосование завершено',
            5: 'Собрание завершилось',
        };

        const annualOrUnscheduled = meeting.annual_or_unscheduled ? 'Годовое' : 'Внеочередное';
        const interOrExtraMural = meeting.inter_or_extra_mural ? 'Очное' : 'Заочное';
        const status = statusMapping[meeting.status] || '-';

        // Создаем массив опций для выпадающего списка эмитентов
        const options = this.state.issuersData?.map((issuerItem) => ({
            value: issuerItem.full_name,
            label: issuerItem.full_name,
            address: issuerItem.address,
            issuer_id: issuerItem.issuer_id,
        })) || [];

        this.setState({
            MeetingName: meeting.meeting_name || '',
            MeetingLocation: meeting.meeting_location || '',
            DesicionDate: meeting.decision_date || '',
            DeadlineDate: meeting.deadline_date || '',
            ProtocolDate: meeting.protocol_date || '',
            RecordDate: meeting.record_date || '',
            MeetingDate: meeting.meeting_date || '',
            CheckinTime: meeting.checkin || '',
            MeetingOpenTime: meeting.meeting_open || '',
            VoteCountingTime: meeting.vote_counting || '',
            AnnualOrUnscheduled: annualOrUnscheduled,
            InterOrExtraMural: interOrExtraMural,
            Status: status,
            EarlyRegistration: meeting.early_registration || false,
            FirstOrRepeated: meeting.first_or_repeated || false,
            MeetingClose: meeting.meeting_close || '',
            Closeout: meeting.closeout || '',
            RegistrarId: meeting.registrar || '',
            MeetingUrl: meeting.meeting_url || '',
            IssuerId: meeting.issuer || '',
            issuerInput: issuer.full_name || '',
            address: issuer.address || '',
            selectedIssuer: options.find(opt => opt.value === issuer.full_name) || null,
            issuerId: meeting.issuer || '',
            loading: false,
        });
    };

    handleIssuerChange = (selectedOption) => {
        if (selectedOption) {
            this.setState({
                selectedIssuer: selectedOption.value,
                issuerInput: selectedOption.label,
                address: selectedOption.address,
                issuerId: selectedOption.issuer_id,
                IssuerId: selectedOption.issuer_id,
            });
        } else {
            this.setState({
                selectedIssuer: null,
                issuerInput: "",
                address: "",
                issuerId: "",
                IssuerId: "",
            });
        }
    };

    handleChange = (e) => {
        const { name, type, checked } = e.target;

        let newValue;
        if (type === 'checkbox') {
            newValue = checked;
        } else {
            newValue = e.target.value;

            if (['IssuerId', 'RegistrarId'].includes(name)) {
                const originalValue = newValue;
                newValue = newValue.replace(/[^0-9]/g, '');
                if (originalValue !== newValue) {
                    enqueueSnackbar('Поле должно содержать только числа', { variant: 'error' });
                }
            }

            if (name === 'AnnualOrUnscheduled') {
                newValue = e.target.value;
            }
            if (name === 'InterOrExtraMural') {
                newValue = e.target.value;
            }
            if (name === 'Status' && !newValue) {
                newValue = '-';
            }
        }

        this.setState({ [name]: newValue }, () => {
            this.checkFieldsCompletion();
        });
    };

    checkFieldsCompletion = () => {
        const {
            AnnualOrUnscheduled,
            Status,
            EarlyRegistration,
            FirstOrRepeated,
            InterOrExtraMural,
            MeetingName,
            MeetingLocation,
            DesicionDate,
            DeadlineDate,
            ProtocolDate,
            RecordDate,
            MeetingDate,
            CheckinTime,
            MeetingOpenTime,
            VoteCountingTime,
            MeetingUrl,
            IssuerId,
            RegistrarId
        } = this.state;

        const fieldsToCheck = [
            AnnualOrUnscheduled,
            Status,
            EarlyRegistration,
            FirstOrRepeated,
            InterOrExtraMural,
            MeetingName,
            MeetingLocation,
            DesicionDate,
            DeadlineDate,
            ProtocolDate,
            RecordDate,
            MeetingDate,
            CheckinTime,
            MeetingOpenTime,
            VoteCountingTime,
            MeetingUrl,
            IssuerId,
            RegistrarId
        ];

        const isCompleted = fieldsToCheck.every(field => field !== '' && field !== '-');

        this.setState({ isButtonDisabled: !isCompleted });
    };

    handleSaveClick = async () => {
        const {
            MeetingName,
            MeetingLocation,
            DesicionDate,
            DeadlineDate,
            ProtocolDate,
            RecordDate,
            MeetingDate,
            CheckinTime,
            MeetingOpenTime,
            VoteCountingTime,
            AnnualOrUnscheduled,
            InterOrExtraMural,
            Status,
            EarlyRegistration,
            FirstOrRepeated,
            MeetingClose,
            Closeout,
            RegistrarId,
            MeetingUrl,
            IssuerId,
            meetingId
        } = this.state;

        const data = {
            MeetingName,
            MeetingLocation,
            DesicionDate,
            DeadlineDate,
            ProtocolDate,
            RecordDate,
            MeetingDate,
            CheckinTime,
            MeetingOpenTime,
            VoteCountingTime,
            AnnualOrUnscheduled: AnnualOrUnscheduled === 'Годовое',
            InterOrExtraMural: InterOrExtraMural === 'Очное',
            Status,
            EarlyRegistration,
            FirstOrRepeated,
            MeetingClose,
            Closeout,
            RegistrarId,
            MeetingUrl,
            IssuerId,
        };

        const fieldsToCheck = [
        AnnualOrUnscheduled,
        Status,
        EarlyRegistration,
        FirstOrRepeated,
        InterOrExtraMural,
        MeetingName,
        MeetingLocation,
        DesicionDate,
        DeadlineDate,
        ProtocolDate,
        RecordDate,
        MeetingDate,
        CheckinTime,
        MeetingOpenTime,
        VoteCountingTime,
        MeetingUrl,
        IssuerId,
        RegistrarId
    ];

        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;

        try {
            const response = await fetch(`${API_ADDRESS}update_meeting/${meetingId}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                body: JSON.stringify(data)
            });

            if (response.ok) {
                const result = await response.json();
                enqueueSnackbar('Собрание успешно обновлено', { variant: 'success' });
            } else {
                const errorData = await response.json();
                enqueueSnackbar('Ошибка при обновлении собрания', { variant: 'error' });
            }
        } catch (error) {
            console.error('Ошибка:', error);
        }
    };

    render() {
        const {
            MeetingName,
            MeetingLocation,
            DesicionDate,
            DeadlineDate,
            ProtocolDate,
            RecordDate,
            MeetingDate,
            CheckinTime,
            MeetingOpenTime,
            VoteCountingTime,
            AnnualOrUnscheduled,
            InterOrExtraMural,
            Status,
            EarlyRegistration,
            FirstOrRepeated,
            MeetingClose,
            Closeout,
            RegistrarId,
            MeetingUrl,
            IssuerId,
            address,
            issuerId,
            issuerInput,
            issuersData,
            loading,
        } = this.state;

        if (loading) {
            return <Loading />;
        }

        const options = issuersData?.map((issuer) => ({
            value: issuer.full_name,
            label: issuer.full_name,
            address: issuer.address,
            issuer_id: issuer.issuer_id,
        })) || [];

        const { Text } = Typography;
        const { Option } = Select;
        const AntSelect = Select;

        return (
            <>
                <div className="page-container">
                    {/* Единый контейнер: заголовок, меню и форма */}
                    <div className="vmr-container">
                        {/* Заголовок с кнопкой "назад" */}
                        <div className="vmr-header">
                            <div className="back-button-wrapper" onClick={this.handleBackClick}>
                                <ArrowLeftOutlined
                                    style={{fontSize: '20px', cursor: 'pointer', marginTop: '4px'}}
                                />
                            </div>
                            <h1 className="vmr-header-title">
                                Редактирование описания собрания
                            </h1>
                        </div>

                        {/* Основная область: меню + форма */}
                        <div className="vmr-main-layout">
                            {/* Левое меню — разделённое на два блока */}
                            <div className="vmr-sidebar-container">
                                {/* Первое меню: Сохранить */}
                                <Menu
                                    mode="inline"
                                    style={{
                                        border: '1px solid #ccc',
                                        borderRadius: '8px',
                                        backgroundColor: '#fff',
                                        marginBottom: '12px'
                                    }}
                                >
                                    <Menu.Item
                                        key="save"
                                        icon={<SaveOutlined/>}
                                        className="menu-item-color"
                                        onClick={this.handleSaveClick}
                                    >
                                        Сохранить
                                    </Menu.Item>
                                </Menu>

                                {/* Второе меню: Навигация по разделам */}
                                <Menu
                                    mode="inline"
                                    style={{
                                        border: '1px solid #ccc',
                                        borderRadius: '8px',
                                        backgroundColor: '#fff',
                                    }}
                                >
                                    <Menu.Item
                                        key="agenda"
                                        icon={<FileDoneOutlined/>}
                                        onClick={this.handleRedactAgenda}
                                    >
                                        Список вопросов
                                    </Menu.Item>
                                    <Menu.Item
                                        key="docs"
                                        icon={<FolderOpenOutlined/>}
                                        onClick={this.handleRedactDocs}
                                    >
                                        Материалы
                                    </Menu.Item>
                                </Menu>
                            </div>

                            {/* Правая часть: форма редактирования */}
                            <div className="vmr-form">
                                <Descriptions
                                    bordered
                                    column={2}
                                    size="middle"
                                    items={[
                                        {
                                            key: 'issuer',
                                            label: 'Эмитент',
                                            children: (
                                                <AntSelect
                                                    showSearch
                                                    value={issuerInput}
                                                    onSelect={(value, option) => this.handleIssuerChange(option)}
                                                    options={options}
                                                    placeholder="Выберите эмитента"
                                                    style={{width: '100%'}}
                                                    optionFilterProp="label"
                                                />
                                            ),
                                            span: 2,
                                        },
                                        {
                                            key: 'address',
                                            label: 'Место нахождения',
                                            children: (
                                                <Text strong>
                                                    {address ? address : (
                                                        <span style={{fontStyle: 'italic'}}>
                                                        Заполняется автоматически
                                                    </span>
                                                    )}
                                                </Text>
                                            ),
                                            span: 2,
                                        },
                                        {
                                            key: 'issuerId',
                                            label: 'Код эмитента',
                                            children: (
                                                <Text strong>
                                                    {issuerId ? issuerId : (
                                                        <span style={{fontStyle: 'italic'}}>
                                                        Заполняется автоматически
                                                    </span>
                                                    )}
                                                </Text>
                                            ),
                                            span: 1,
                                        },
                                        {
                                            key: 'registrarId',
                                            label: 'Код регистратора',
                                            children: <Text strong>{RegistrarId}</Text>,
                                            span: 1,
                                        },
                                        {
                                            key: 'registrar',
                                            label: 'Регистратор',
                                            children: <Text strong>{this.state.RegistrarName}</Text>,
                                            span: 2,
                                        },
                                        {
                                            key: 'meetingName',
                                            label: 'Описание собрания',
                                            children: (
                                                <Input
                                                    name="MeetingName"
                                                    value={MeetingName}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                            span: 2,
                                        },
                                        {
                                            key: 'meetingLocation',
                                            label: 'Место проведения / Почтовый адрес',
                                            children: (
                                                <Input
                                                    name="MeetingLocation"
                                                    value={MeetingLocation}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                            span: 2,
                                        },
                                        {
                                            key: 'meetingUrl',
                                            label: 'Ссылка на трансляцию',
                                            children: (
                                                <Input
                                                    name="MeetingUrl"
                                                    value={MeetingUrl}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                            span: 1,
                                        },
                                        {
                                            key: 'decisionDate',
                                            label: 'Дата принятия решения',
                                            children: (
                                                <Input
                                                    type="date"
                                                    name="DesicionDate"
                                                    value={DesicionDate}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'deadlineDate',
                                            label: 'Дата окончания приёма',
                                            children: (
                                                <Input
                                                    type="date"
                                                    name="DeadlineDate"
                                                    value={DeadlineDate}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'protocolDate',
                                            label: 'Дата составления протокола',
                                            children: (
                                                <Input
                                                    type="date"
                                                    name="ProtocolDate"
                                                    value={ProtocolDate}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'recordDate',
                                            label: 'Дата составления списка',
                                            children: (
                                                <Input
                                                    type="date"
                                                    name="RecordDate"
                                                    value={RecordDate}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'meetingDate',
                                            label: 'Дата собрания',
                                            children: (
                                                <Input
                                                    type="date"
                                                    name="MeetingDate"
                                                    value={MeetingDate}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'checkin',
                                            label: 'Начало регистрации',
                                            children: (
                                                <Input
                                                    type="datetime-local"
                                                    name="CheckinTime"
                                                    value={CheckinTime}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'closeout',
                                            label: 'Окончание регистрации',
                                            children: (
                                                <Input
                                                    type="datetime-local"
                                                    name="Closeout"
                                                    value={Closeout}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'meetingOpen',
                                            label: 'Начало собрания',
                                            children: (
                                                <Input
                                                    type="datetime-local"
                                                    name="MeetingOpenTime"
                                                    value={MeetingOpenTime}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'meetingClose',
                                            label: 'Окончание собрания',
                                            children: (
                                                <Input
                                                    type="datetime-local"
                                                    name="MeetingClose"
                                                    value={MeetingClose}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'voteCounting',
                                            label: 'Начало подсчёта голосов',
                                            children: (
                                                <Input
                                                    type="datetime-local"
                                                    name="VoteCountingTime"
                                                    value={VoteCountingTime}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'annualOrUnscheduled',
                                            label: 'Вид собрания',
                                            children: (
                                                <AntSelect
                                                    name="AnnualOrUnscheduled"
                                                    value={AnnualOrUnscheduled}
                                                    onChange={(value) => this.setState({AnnualOrUnscheduled: value})}
                                                    style={{width: '100%'}}
                                                >
                                                    <Option value="Годовое">Годовое</Option>
                                                    <Option value="Внеочередное">Внеочередное</Option>
                                                    <Option value="Годовое повторное">Годовое повторное</Option>
                                                    <Option value="Внеочередное повторное">Внеочередное
                                                        повторное</Option>
                                                </AntSelect>
                                            ),
                                        },
                                        {
                                            key: 'firstOrRepeated',
                                            label: 'Повторное собрание',
                                            children: (
                                                <input
                                                    type="checkbox"
                                                    name="FirstOrRepeated"
                                                    checked={FirstOrRepeated}
                                                    onChange={this.handleChange}
                                                    style={{transform: 'scale(1.2)'}}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'status',
                                            label: 'Статус',
                                            children: (
                                                <AntSelect
                                                    name="Status"
                                                    value={Status}
                                                    onChange={(value) => this.setState({Status: value})}
                                                    style={{width: '100%'}}
                                                >
                                                    <Option value="Ожидается">Ожидается</Option>
                                                    <Option value="Разрешена регистрация">Разрешена регистрация</Option>
                                                    <Option value="Разрешено голосование">Разрешено голосование</Option>
                                                    <Option value="Голосование завершено">Голосование завершено</Option>
                                                    <Option value="Собрание завершилось">Собрание завершилось</Option>
                                                </AntSelect>
                                            ),
                                        },
                                        {
                                            key: 'earlyRegistration',
                                            label: 'Досрочная регистрация',
                                            children: (
                                                <input
                                                    type="checkbox"
                                                    name="EarlyRegistration"
                                                    checked={EarlyRegistration}
                                                    onChange={this.handleChange}
                                                    style={{transform: 'scale(1.2)'}}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'interOrExtraMural',
                                            label: 'Форма собрания',
                                            children: (
                                                <AntSelect
                                                    name="InterOrExtraMural"
                                                    value={InterOrExtraMural}
                                                    onChange={(value) => this.setState({InterOrExtraMural: value})}
                                                    style={{width: '100%'}}
                                                >
                                                    <Option value="Очное">Очное</Option>
                                                    <Option value="Заочное">Заочное</Option>
                                                </AntSelect>
                                            ),
                                        },
                                    ]}
                                    labelStyle={{fontWeight: 'bold', backgroundColor: '#fafafa'}}
                                    contentStyle={{padding: '10px 12px'}}
                                    className="custom-descriptions"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

}

export default VoteMeetingRedact;